import { PosCampanhaServiceAba8 } from './../../../service/posCampanhaAba8/pos-campanha-aba8.service';
import { Component, Input, OnInit, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatTableDataSource } from '@angular/material/table';
import { ServidorRecad } from 'app/model/servidorRecad';
import { ContatoPosRecadDTO } from './contatoPosRecad.dto';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { ModalComponent } from 'app/components/modal/modal.component';

type DadosTabela = {
  descricao: string;
  informacaoSrh: string;
  informacaoRecad: string;
}

@Component({
  selector: 'app-aba8-posrecad',
  templateUrl: './aba8-posrecad.component.html',
  styleUrls: ['./aba8-posrecad.component.sass']
})
export class Aba8PosrecadComponent implements OnInit {
  @Input() servidor: ServidorRecad;
  @Output() flExibirTab: EventEmitter<any> = new EventEmitter<any>();
  @Output() salvoOutput: EventEmitter<any> = new EventEmitter<any>();
  @Output() botoesDesabilitadosContatos: EventEmitter<any> = new EventEmitter<any>();
  @Input() btnDesativadoContatos: boolean;
  displayedColumns: string[] = ['descricao', 'informacaoSrh', 'informacaoRecad'];
  color: ThemePalette = 'primary';
  list: DadosTabela[] = [];


  dataSource: MatTableDataSource<DadosTabela> = new MatTableDataSource<DadosTabela>([]);
  contatos: ContatoPosRecadDTO;
  salvo: boolean = false;
  panelOpenState = false;

  justificativa: string = '';
  isDisabledJustificativa: boolean = true
  recadValidacaoContatoId: number;
  recadServidorId: number;
  validacaoRecadId: number; 

  constructor(private toasterService: ToastrService, public dialog: MatDialog, private posCampanhaServiceAba8: PosCampanhaServiceAba8) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.servidor && changes.servidor.currentValue) {
      this.dataSource.data = [];
      this.list = [];
      this.salvo = false;
      this.justificativa = "";
      this.processarContatos(this.servidor.id);
    }
  }

  private getObterContatos(recadServidorId: number): Observable<ContatoPosRecadDTO> {
    return this.posCampanhaServiceAba8.getObterContato(recadServidorId);
  }

  processarContatos(validacaoRecadId: number) {
    this.getObterContatos(validacaoRecadId).subscribe(
      response => {
        this.contatos = response
        if (response) {
          // this.contatos = response;
          this.dataSource.data = this.montarDadosTabela(response);
        } else {
          this.flExibirTab.emit(false);
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }
  private formatarTelefone(telefone: string): string {
    if (!telefone) {
      return '';
    }

    telefone = telefone.toString();

    if (telefone.length === 8) {
      return telefone.replace(/(\d{4})(\d{4})/, '$1-$2');
    } else if (telefone.length === 9) {
      return telefone.replace(/(\d{5})(\d{4})/, '$1-$2');
    } else {
      return telefone;
    }
  }
  private montarDadosTabela(resp: ContatoPosRecadDTO): DadosTabela[] {
    this.list.push(
      {
        descricao: "Telefone Residencial",
        informacaoSrh: (resp.numeDddTelSrh != null ? resp.numeDddTelSrh : '') + ' ' + (resp.numeTelResSrh != null ? this.formatarTelefone(resp.numeTelResSrh) : ''),
        informacaoRecad: (resp.numeDddTelRecad != null ? resp.numeDddTelRecad : '') + ' ' + (resp.numeTelResRecad != null ? this.formatarTelefone(resp.numeTelResRecad) : '')

      },
      {
        descricao: "Telefone Celular",
        informacaoSrh: (resp.numeDddCelularSrh != null ? resp.numeDddCelularSrh : '') + ' ' + (resp.numeCelularSrh != null ? this.formatarTelefone(resp.numeCelularSrh) : ''),
        informacaoRecad: (resp.numeDddCelularRecad != null ? resp.numeDddCelularRecad : '') + ' ' + (resp.numeCelularRecad != null ? this.formatarTelefone(resp.numeCelularRecad) : ''),

      },
      {
        descricao: "Telefone Residencial/Celular",
        informacaoSrh: (resp.numeDddTelCelularSrh != null ? resp.numeDddTelCelularSrh : '') + ' ' + (resp.numeTelCelularSrh != null ? this.formatarTelefone(resp.numeTelCelularSrh) : ''),
        informacaoRecad: (resp.numeDddTelCelularRecad != null ? resp.numeDddTelCelularRecad : '') + ' ' + (resp.numeTelCelularRecad != null ? this.formatarTelefone(resp.numeTelCelularRecad) : ''),

      },
      {
        descricao: "E-mail Particular",
        informacaoSrh: resp.emailPessoalSrh != null ? resp.emailPessoalSrh : '',
        informacaoRecad: resp.emailPessoalRecad != null ? resp.emailPessoalRecad : '',

      }
    );

    return this.list;
  }

  openDialog(): void {
    this.dialog.open(ModalComponent, {
      width: '450px',
      data: {
        header: 'Justificativa',
        descricao: 'Justifique o motivo de recusa:',
        labelOne: 'Cancelar',
        labelTwo: 'Salvar',
        flTextArea: true,
        action: (justificativa: string) => {
          this.justificativa = justificativa;
          this.aprovar(3)
          this.botoesDesabilitadosContatos.emit(true);
        }
      }
    });
  }

  rejeitar() {
    this.isDisabledJustificativa = false
    this.openDialog();

  }


  aprovar(status) {
    /*
    status
    1- aceito
    2-pendente
    3- recusado
    * */
    this.botoesDesabilitadosContatos.emit(true);
    if (status == 1) {
      this.justificativa = ''
    }
    let body = {
      id: this.servidor.id,
      status: status,
      justificativa: this.justificativa,

    }
    this.posCampanhaServiceAba8.postDadosContato(body).subscribe(resp => {
      this.toasterService.success("Dados salvos com sucesso");
      this.salvo = true;
      this.salvoOutput.emit(true);
    },
    (error) => {
      this.toasterService.error('Erro ao salvar os dados.', '', {
        timeOut: 1500
      });
    });
  }
}
